import { render, staticRenderFns } from "./DiningOptions.vue?vue&type=template&id=aa01022c&"
import script from "./DiningOptions.vue?vue&type=script&lang=js&"
export * from "./DiningOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports